// src/pages/AnaokuluPage.jsx
import React from 'react';
import NavBar from '../components/NavBar';
import ContactSection from '../components/ContactSection';
import './AnaokuluPage.css';
import anaokuluImg from '../assets/sokullu.jpg';
import img1 from '../assets/a1.jpeg';
import img2 from '../assets/a2.jpeg';
import img3 from '../assets/a3.jpeg';
import img4 from '../assets/a4.jpg';
import img5 from '../assets/a5.jpeg';
import img6 from '../assets/a6.jpeg';
import img7 from '../assets/a7.jpeg';
import img8 from '../assets/a8.jpeg';

export default function AnaokuluPage() {
  return (
    <>
      <NavBar />

      <section id="anaokulu-page" className="anaokulu-page">
        {/* Hero Başlık */}
        <div className="hero">
          <img src={anaokuluImg} alt="Anaokulu" className="hero-img" />
          <div className="overlay" />
          <h1 className="hero-title">Anaokulu</h1>
        </div>

        {/* Metin İçeriği */}
        <div className="content">
          <h2>Küçük Kalpler, Büyük Keşifler</h2>
          <p>
            Her çocuğun büyümesi bir tohumun filizlenmesi gibidir. Sevgiyle, sabırla,
            doğallıkla… Biz, çocukların kendilerini güvende hissettikleri, oyunla
            öğrendikleri ve doğayla bağ kurdukları bir anaokulu hayal ettik — ve bu
            hayali gerçeğe dönüştürdük.
          </p>

          <h2>Oyun Temelli, Merak Odaklı Eğitim</h2>
          <p>
            Çocuklar oyunla öğrenir, oyunla gelişir. Anaokulumuzda yapılandırılmış
            etkinliklerden çok, özgür oyun alanlarına, deneyimsel öğrenmeye ve çocuğun
            içsel motivasyonuna alan tanırız. Sorular sormalarına, keşfetmelerine ve hata
            yapmalarına cesaret veririz. Çünkü her “neden?” sorusu yeni bir kapı açar.
          </p>

          <h2>Her Çocuk Benzersizdir</h2>
          <p>
            Biz her çocuğa aynı gözle bakmayız. Onları kendi bireysellikleriyle tanır,
            ilgi alanlarını ve gelişim ritimlerini dikkate alırız. Duygularını tanımaları,
            ifade etmeleri ve arkadaşlık kurmaları için güvenli bir sosyal ortam
            oluştururuz.
          </p>

          <h2>Doğayla İç İçe Bir Büyüme</h2>
          <p>
            Bahçede çıplak ayakla koşmak, bir ağaca sarılmak ya da bir yaprağın altındaki
            tırtılı gözlemlemek… Bizim için doğa bir öğretmen, bir oyun arkadaşı ve bir
            iyileştirici güçtür. Dört mevsimi hissederek, toprağa dokunarak, çevreye saygı
            duyarak büyümeleri için fırsatlar sunarız.
          </p>

          <h2>Sanat, Hareket ve Ritmle Dolu Günler</h2>
          <p>
            Boyalarla özgürce karalamak, ritme uyarak dans etmek ya da bir hikâyeyi
            canlandırmak… Sanat ve hareket, çocukların kendilerini ifade etmeleri için en
            doğal yollar. Anaokulumuzda kalıplardan çok duyguların izini süreriz.
          </p>

          <h2>Güven, Şefkat ve Sınır</h2>
          <p>
            Çocuklar için güvenli bir bağ kurmak, öğrenmenin temelidir. Her çocuğun
            “görülme” ve “duyulma” ihtiyacına özen gösteririz. Sınırlar nettir ama
            sevgiyle çizilidir. Disiplin, ceza değil rehberliktir. Çocuklarda geliştirmek
            istediğimiz özellik öz disiplindir.
          </p>
        </div>

        {/* Görseller */}
        <div className="images-grid">
          <img src={img1} alt="Etkinlik 1" />
          <img src={img2} alt="Etkinlik 2" />
          <img src={img3} alt="Etkinlik 3" />
          <img src={img4} alt="Etkinlik 4" />
          <img src={img5} alt="Etkinlik 5" />
          <img src={img6} alt="Etkinlik 6" />
          <img src={img7} alt="Etkinlik 7" />
          <img src={img8} alt="Etkinlik 8" />
        </div>

        {/* İletişim Bölümü: ZEZE’nin Bahçesi ve Dikmen VIP Kurs çıkartıldı */}
        <div className="anaokulu-contact">
          <h2 className="anaokulu-contact__title">Anaokullarımız</h2>
          <ContactSection
            excludeIds={[4, 5]}               
            titleOverrides={{ 3: ' Dikmen Yeldeğirmeni Anaokulu' }}
          />
        </div>
      </section>
    </>
  );
}
